export const initialState = {
    loading: false,
    owner:null,
    owners: [],
    response: { message: null, error: null },
    
}